import React from "react";
import { EmailSubscribeForm } from "./forms/email-subscribe-form";
import { createRoot } from "react-dom/client";

const EmailSubscribe = (props: {
  location: string;
  headline?: string;
  onSubscribed?: () => void;
  mini?: boolean;
}) => {
  return (
    <div className="email-subscribe">
      <h5>{props.headline || "Få lokale nyheder GRATIS"}</h5>
      <EmailSubscribeForm
        location={props.location}
        onSubscribed={props.onSubscribed}
        hasAutofocus={false}
      />
    </div>
  );
};

const emailSignupWidgets = document.getElementsByTagName("email-signup-widget");

for (let i = 0; i < emailSignupWidgets.length; i++) {
  const element = emailSignupWidgets.item(i) as HTMLElement;
  const location = element.dataset.location;
  const root = createRoot(element);
  root.render(
    <EmailSubscribe location={location!} headline={element.dataset.headline} />
  );
}
